import type { OutlookSpaceId } from '../serviceTypes/OutlookSpaceId';
import { isGuid } from 'owa-guid';

export default function isOutlookSpaceId(
    value: string | null | undefined
): value is OutlookSpaceId {
    return !!value && isGuid(value);
}
